export default __webpack_public_path__ + "static/media/comic.0d28dfc3.svg";